import styled, { css } from 'styled-components';
import { DatePicker as DatePickerDesktop } from 'antd';
import { List, ConfigProvider } from 'antd';
import enUS from 'antd/es/locale-provider/en_US';
import frFR from 'antd/es/locale-provider/fr_FR';
import nlNL from 'antd/es/locale-provider/nl_NL'; // dutch translations for the netherlands
import DatePicker from 'antd-mobile/es/date-picker';
import LocaleProvider from 'antd-mobile/es/locale-provider';
import 'antd-mobile/es/date-picker/style/css';
import { getTranslatedString, getCurrentLocale } from 'helpers/i18n';
import MediaQuery from 'react-responsive';
import React from 'react';
import moment from 'moment';
import { toMomentDate } from 'helpers/Formatter';

const StyledDatePickerDesktop = styled(DatePickerDesktop)``;

const StyledDatePickerMobile = styled(DatePicker)``;

const StyledErrorDiv = styled.div`
  ${({ error }) =>
    error &&
    `
    border: 1px solid red !important;
    border-radius: 4px;
  `};
`;

const StyledListItem = styled(List.Item)`
  background: white;
  padding: 0 15px !important;
  border-radius: 4px;
  border: #d9d9d9 solid 1px;
  height: 40px;
  flex-wrap: nowrap !important;
  ${({ active }) =>
    active &&
    `
     color: #c5c5c5 !important;
  `};
`;

const YuhuDatePicker = ({
  children,
  mobileMode,
  value,
  defaultValue,
  onChange,
  showTime,
  ...rest
}) => {
  const StyledBaseDatePicker = (
    <style>
      {css`
        .ant-picker-dropdown {
          z-index: 1301 !important; // upgrade of antd to v4 without this, antd drawer's z-index hides the datepicker calendar dropdown
        }
      `}
    </style>
  );
  const minDate = (
    rest.minDate ? moment(rest.minDate, 'YYYY-MM-DD') : moment().subtract(110, 'year')
  ).toDate();
  const maxDate = (
    rest.maxDate ? moment(rest.maxDate, 'YYYY-MM-DD') : moment().add(110, 'year')
  ).toDate();

  const disabledDate = (date) => {
    return !(
      date.isSame(minDate, 'day') ||
      date.isBetween(moment(minDate).startOf('day'), moment(maxDate).endOf('day'))
    );
  };

  const antLocalize = (locale) => {
    let result;
    switch (locale) {
      case 'en':
        result = enUS;
        break;
      case 'fr':
        result = frFR;
        break;
      case 'nl':
        result = nlNL;
        break;
      default:
        result = enUS;
    }
    return result;
  };

  const mobileDatetimeValue = (date) => {
    if (!date) return null;
    if (showTime) return new Date(date);

    return new Date(`${date}T00:00`);
  };

  let dateFormat = 'YYYY-MM-DD';
  if (showTime) {
    dateFormat = 'YYYY-MM-DD hh:mm a';
  }

  return (
    <React.Fragment>
      <MediaQuery query="(max-device-width: 750px)">
        <LocaleProvider locale={antLocalize(getCurrentLocale())}>
          <StyledErrorDiv {...rest}>
            <StyledDatePickerMobile
              {...rest}
              locale={{
                okText: getTranslatedString('datePicker.ok'),
                dismissText: getTranslatedString('datePicker.cancel'),
              }}
              onChange={(date) => onChange(toMomentDate(date).format(dateFormat))}
              value={value ? mobileDatetimeValue(value) : null}
              mode={mobileMode}
              extra={rest.placeholder}
              maxDate={maxDate}
              minDate={minDate}
            >
              <StyledListItem active={!value} arrow="horizontal" />
            </StyledDatePickerMobile>
          </StyledErrorDiv>
        </LocaleProvider>
      </MediaQuery>
      <MediaQuery query="(min-device-width: 750px)">
        <ConfigProvider locale={antLocalize(getCurrentLocale())}>
          {StyledBaseDatePicker}
          <StyledDatePickerDesktop
            defaultValue={moment(defaultValue)}
            value={value ? moment(value) : null}
            onChange={(date) => (date ? onChange(date.format(dateFormat)) : onChange(null))}
            showTime={showTime}
            disabledDate={disabledDate}
            {...rest}
          >
            {children}
          </StyledDatePickerDesktop>
        </ConfigProvider>
      </MediaQuery>
    </React.Fragment>
  );
};

export default YuhuDatePicker;
